import { jsx as r, jsxs as d } from "react/jsx-runtime";
import { H as g, b as B, c as C, S as $ } from "./24x24-BdiyggP2.mjs";
import { useState as x } from "react";
import { g as N } from "./_commonjsHelpers-DaMA6jEr.mjs";
const T = "_Body_15vlo_26", S = "_Caption_15vlo_31", q = "_Tiny_15vlo_36", M = "_ButtonM_15vlo_49", H = "_ButtonS_15vlo_54", f = {
  Body: T,
  Caption: S,
  Tiny: q,
  ButtonM: M,
  ButtonS: H
}, ct = ({ children: s, size: o = "small", variant: e, dark: i, ...a }) => {
  const t = `wrapper ${o === "medium" ? "size-medium" : "size-small"} ${f.Tiny}`, n = {
    "--badge-text-color": i ? "var(--white)" : `var(--${e}-50)`,
    "--badge-bg-color": `var(--${e}-${i ? 40 : 10})`,
    ...a
  };
  return /* @__PURE__ */ r("div", { className: t, style: n, children: s });
};
var w = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var y;
function L() {
  return y || (y = 1, function(s) {
    (function() {
      var o = {}.hasOwnProperty;
      function e() {
        for (var t = "", n = 0; n < arguments.length; n++) {
          var c = arguments[n];
          c && (t = a(t, i(c)));
        }
        return t;
      }
      function i(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return e.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var n = "";
        for (var c in t)
          o.call(t, c) && t[c] && (n = a(n, c));
        return n;
      }
      function a(t, n) {
        return n ? t ? t + " " + n : t + n : t;
      }
      s.exports ? (e.default = e, s.exports = e) : window.classNames = e;
    })();
  }(w)), w.exports;
}
var P = L();
const v = /* @__PURE__ */ N(P), j = "_container_1spck_2", E = "_tooltipBody_1spck_12", F = "_pointer_1spck_82", m = {
  container: j,
  tooltipBody: E,
  pointer: F,
  "tooltip-question-wrapper": "_tooltip-question-wrapper_1spck_129"
}, A = (s) => /* @__PURE__ */ r(
  "svg",
  {
    width: "24",
    height: "8",
    viewBox: "0 0 24 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...s,
    children: /* @__PURE__ */ r(
      "path",
      {
        d: "M24 0V0.00171492C22.8155 0.00840678 22.1125 0.0412078 21.5083 0.201989C20.8354 0.381051 20.1934 0.676253 19.607 1.07629C18.9455 1.52754 18.3834 2.15794 17.2593 3.41875L15.186 5.74412C14.0745 6.99082 13.5187 7.61417 12.8735 7.84668C12.3063 8.05111 11.6932 8.05111 11.1259 7.84668C10.4808 7.61417 9.92499 6.99082 8.81344 5.74412L6.74016 3.41875C5.61604 2.15794 5.05398 1.52754 4.39247 1.07629C3.80606 0.676255 3.16409 0.381053 2.49116 0.201991C1.90672 0.0464747 1.19182 0.0106943 1.9813e-10 0.00246231L0 2.2739e-06L24 0Z",
        fill: "currentColor"
      }
    )
  }
), D = ({ position: s, align: o }) => /* @__PURE__ */ r(A, { className: m.pointer, "data-position": s, "data-align": o }), O = ({ align: s, position: o, children: e }) => /* @__PURE__ */ r("div", { className: m.tooltipBody, "data-align": s, "data-position": o, children: e }), V = ({
  children: s,
  value: o,
  position: e = "bottom",
  align: i = "center",
  className: a
}) => /* @__PURE__ */ d("div", { className: v(m.container, a), children: [
  /* @__PURE__ */ d(O, { position: e, align: i, children: [
    o,
    /* @__PURE__ */ r(D, { position: e, align: i })
  ] }),
  s
] }), lt = ({ icon: s, children: o, ...e }) => /* @__PURE__ */ r(
  V,
  {
    value: o,
    ...e,
    className: v(e.className, m["tooltip-question-wrapper"]),
    children: s || /* @__PURE__ */ r(g, {})
  }
), k = "_base_1feab_1", z = "_checked_1feab_19", h = {
  base: k,
  checked: z
}, _t = ({
  className: s,
  isChecked: o = !1,
  onClick: e,
  ...i
}) => {
  const [a, t] = x(!1), n = () => t(!0), c = () => t(!1), u = `
    ${h.base} 
    ${o ? h.checked : ""}
    ${s || ""}
  `, b = (_) => {
    _.preventDefault(), _.stopPropagation(), e == null || e(_);
  };
  return /* @__PURE__ */ r(
    "button",
    {
      type: "button",
      className: u.trim(),
      onMouseEnter: n,
      onMouseLeave: c,
      "aria-pressed": o,
      onClick: b,
      ...i,
      children: a || o ? /* @__PURE__ */ r(B, {}) : /* @__PURE__ */ r(C, {})
    }
  );
}, I = "_baseButton_1wwfs_1", Q = "_buttonText_1wwfs_29", R = "_buttonContent_1wwfs_37", Z = "_small_1wwfs_57", G = "_normal_1wwfs_61", J = "_primary_1wwfs_66", K = "_confirmative_1wwfs_82", U = "_confimative_1wwfs_86", W = "_destructive_1wwfs_93", X = "_alternative_1wwfs_104", Y = "_ghost_1wwfs_115", tt = "_secondary_1wwfs_132", et = "_spinner_1wwfs_145", st = "_spin_1wwfs_145", ot = "_rounded_1wwfs_155", l = {
  baseButton: I,
  buttonText: Q,
  buttonContent: R,
  small: Z,
  normal: G,
  primary: J,
  confirmative: K,
  confimative: U,
  destructive: W,
  alternative: X,
  ghost: Y,
  secondary: tt,
  spinner: et,
  spin: st,
  rounded: ot
}, pt = ({
  children: s,
  isLoading: o,
  size: e = "normal",
  theme: i = "primary",
  rounded: a,
  leadingIcon: t,
  trailingIcon: n,
  isDisabled: c,
  className: u,
  ...b
}) => {
  const _ = `
    ${l.baseButton} 
    ${l[e]} 
    ${l[i]}
    ${e === "small" ? f.ButtonS : f.ButtonM}
    ${a && l.rounded}
    ${!!u && u}
  `;
  return /* @__PURE__ */ d("button", { className: _, disabled: c, ...b, children: [
    /* @__PURE__ */ d("span", { className: l.buttonContent, style: { opacity: o ? 0 : 1 }, children: [
      t,
      s && /* @__PURE__ */ r("span", { children: s }),
      n
    ] }),
    o && /* @__PURE__ */ r($, { className: l.spinner })
  ] });
}, p = {
  "page-button": "_page-button_8qrgh_1",
  "page-selected": "_page-selected_8qrgh_22",
  "page-disabled": "_page-disabled_8qrgh_27",
  "icon-only": "_icon-only_8qrgh_33",
  "page-hover": "_page-hover_8qrgh_37"
}, ut = ({ state: s, icon: o, iconOnly: e, onClick: i, page: a, ...t }) => {
  const n = a ? `Page ${a}` : "More pages";
  return /* @__PURE__ */ r(
    "button",
    {
      disabled: s === "disabled",
      onClick: i,
      "aria-label": e ? "Page Change" : n,
      className: v(p["page-button"], f.Caption, {
        [p["page-selected"]]: s === "selected",
        [p["page-disabled"]]: s === "disabled",
        [p["page-hover"]]: s !== "disabled",
        [p["icon-only"]]: e
      }),
      ...t,
      children: e ? o : a || "..."
    }
  );
};
export {
  pt as B,
  _t as H,
  ut as P,
  f as T,
  V as a,
  lt as b,
  v as c,
  ct as d
};
